//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"Color",1,0],[1,"Level",0,"Expression",0],[0,"Loading",1,0],[0,"Location",1,0],[0,"Name",1,0],[1,"Offset",0,"Expression",0],[0,"PendulumProfile",1,0],[0,"PositionMethod",1,0],[1,"Shift",0,"Expression",0],[0,"ShowPendulum",1,0],[0,"ShowPoint",1,0],[0,"Side",1,0]],[],[]];
SPLM.Features.VehicleDesign.PendulumPlacementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.PendulumPlacementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.PendulumPlacementBuilder.PositionMethodType = Object.freeze({
    "MiddleBaseData" : "MiddleBaseData", "MiddleVehicle" : "MiddleVehicle", "RotatedBaseData" : "RotatedBaseData", "RotatedPlane" : "RotatedPlane", "RotatedPlaneX" : "RotatedPlaneX", "RotatedPlaneNormal" : "RotatedPlaneNormal", "RotatedContact" : "RotatedContact", "ShiftedBaseData" : "ShiftedBaseData", "ShiftedVehicle" : "ShiftedVehicle", "ShiftedFromRotated" : "ShiftedFromRotated"});

SPLM.Features.VehicleDesign.PendulumPlacementBuilder.PendulumProfileType = Object.freeze({
    "Eu" : "Eu", "Us" : "Us"});

SPLM.Features.VehicleDesign.PendulumPlacementBuilder.LocationType = Object.freeze({
    "Front" : "Front", "Rear" : "Rear"});

SPLM.Features.VehicleDesign.PendulumPlacementBuilder.SideType = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

export default SPLM;